<template>
    <span :class="`validator${cssKey}`"
          :name="validationKey" />
</template>

<script>

export default {

    props: {
        for: {
            type: String,
            required: true,
        },
        classModifier: {
            type: String,
            default: '',
        },
    },

    computed: {

        cssKey() {
            return this.classModifier ? ` validator--${ this.classModifier }` : ''
        },

        validationKey() {
            return this.for ? `${ this.for }.validator` : ''
        },
    },
}

</script>


<style lang="scss">

.validator {
    color: $error;
    display: block;
    width: 100%;
}

</style>
